import { render, staticRenderFns } from "./ContratoDialog.vue?vue&type=template&id=231617ea&scoped=true"
import script from "./ContratoDialog.vue?vue&type=script&lang=js"
export * from "./ContratoDialog.vue?vue&type=script&lang=js"
import style0 from "./ContratoDialog.vue?vue&type=style&index=0&id=231617ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231617ea",
  null
  
)

export default component.exports